import React from 'react';

const Forbidden = () => {
    return (
        <div className="forbidden-message text-center">
            <h2 className='text-danger'>Error 403- Forbidden</h2>
            <p className='fw-600'>You do not have permission to access this page.</p>
        </div>
    );
};

export default Forbidden;